import { useSelector } from "react-redux";
import DataTable from "../../../components/common/DataTable/DataTable";
import "./Settlement.css";

function SettlementTable({ dataItem }) {
  const role = useSelector((store) => store.userReducer.role);

  const columns = [];

  if (role === "super" || role === "operation") {
    columns.push({
      key: "userName",
      header: "User Name",
      wrapCell: true,
      render: (row) => row?.userName || row?.userId,
    });
  }

  columns.push(
    {
      key: "amountPaid",
      header: "Amount Paid",
      render: (row) => Number(row?.amountPaid || 0).toFixed(2),
    },
    {
      key: "amountToBePaid",
      header: "Amount Unpaid",
      render: (row) => Number(row?.amountToBePaid || 0).toFixed(2),
    },
    {
      key: "chargeback",
      header: "Chargeback Initiated",
      render: () => 0,
    }
  );

  return (
    <div className="table-main-report">
      <DataTable
        columns={columns}
        data={dataItem || []}
        emptyMessage="No Settlement Data Found"
      />
    </div>
  );
}

export default SettlementTable;